import { useRevalidator } from "react-router";
import { DataLoadError } from "~/components/ui/data-load-error";

/**
 * In-tab error state for company profile sections — keeps the profile shell
 * (header, tabs) rendered when a section endpoint fails, with a retry that
 * re-runs the route loaders. Parity with the old client-side tab error states.
 */
export function SectionError({ message }: { message: string }) {
	const revalidator = useRevalidator();

	return (
		<DataLoadError
			title={message}
			description="Ostatní části profilu zůstávají dostupné."
			onRetry={() => revalidator.revalidate()}
			retrying={revalidator.state !== "idle"}
		/>
	);
}
